import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import LoginForm from './forms/loginForm';
import LoginHeader from './loginHeader/loginHeader';
import LoginFooter from './loginFooter/loginFooter';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import InviteLinkForm from 'pages/loginPage/forms/inviteLinkForm';
import RestoreLinkForm from 'pages/loginPage/forms/restoreLinkForm';
import LoginContainer from 'pages/loginPage/components/loginContainer';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import BackButton from 'shared/lib/components/controls/buttons/backButton';

export type LoginPageFormType = 'login' | 'invite' | 'restore';

export default observer(function LoginPage() {
  const { t } = useTranslation();

  const {
    mobxStore: { authStore },
  } = useContext(MobxContext);

  const signupEmailSend = authStore.signupEmailSend;

  const loc = useLocation();

  const [activeForm, setActiveForm] = useState<LoginPageFormType>(
    loc.hash === '#invite'
      ? 'invite'
      : loc.hash === '#restore'
      ? 'restore'
      : 'login'
  );

  const handleSwitchForm = () => {
    authStore.clearError();
    setActiveForm((prevState) => (prevState === 'login' ? 'invite' : 'login'));
  };

  const setSignin = useCallback(() => {
    setActiveForm('login');
  }, []);

  const headerText =
    activeForm === 'login'
      ? ''
      : activeForm === 'invite'
      ? signupEmailSend
        ? t('login.emailSend')
        : t('login.registration')
      : activeForm === 'restore'
      ? t('common.restoringPassword')
      : '';

  return (
    <LoginContainer innerSx={{ position: 'relative' }}>
      {activeForm === 'restore' && (
        <Box sx={{ position: 'absolute', top: 20, left: 20 }}>
          <BackButton onClick={() => setActiveForm('login')}></BackButton>
        </Box>
      )}

      <LoginHeader text={headerText}></LoginHeader>
      {activeForm === 'login' ? (
        <LoginForm
          onRestoreClick={() => {
            setActiveForm('restore');
          }}
          footer={
            <LoginFooter
              activeForm={activeForm}
              handleSwitchForm={handleSwitchForm}
            ></LoginFooter>
          }
        ></LoginForm>
      ) : activeForm === 'invite' ? (
        <InviteLinkForm onFinishClick={setSignin}></InviteLinkForm>
      ) : activeForm === 'restore' ? (
        <RestoreLinkForm onFinishClick={setSignin}></RestoreLinkForm>
      ) : null}
      {activeForm !== 'login' && (
        <LoginFooter
          activeForm={activeForm}
          handleSwitchForm={handleSwitchForm}
        ></LoginFooter>
      )}
    </LoginContainer>
  );
});
